import type { FC } from "react";

import { Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { ensureHttpsProtocol } from "app/pages/digital-marketing/utils/url";

import type { ICitationCardData } from "./CitationCard";
import { CitationCard } from "./CitationCard";
import { CollapsibleSection } from "./CollapsibleSection";

interface ICitationsSectionProps {
    citations: ICitationCardData[];
    defaultExpanded?: boolean;
    onCitationClick?: (citation: ICitationCardData) => void;
}

export const CitationsSection: FC<ICitationsSectionProps> = ({
    citations,
    defaultExpanded = false,
    onCitationClick,
}) => {
    if (!citations || citations.length === 0) {
        return null;
    }

    const handleCitationClick = (citation: ICitationCardData): void => {
        if (onCitationClick) {
            onCitationClick(citation);
        } else {
            const urlWithProtocol = ensureHttpsProtocol(citation.url);
            window.open(urlWithProtocol, "_blank", "noopener,noreferrer");
        }
    };

    return (
        <CollapsibleSection
            title={translate("llm.sentiment_report.topics.side-panel.citations.title", {
                count: citations.length,
            })}
            defaultExpanded={defaultExpanded}
            margin="16px 0 0 0"
        >
            <Flex
                flexWrap="wrap"
                gap="12px"
                width="100%"
            >
                {citations.map((citation, index) => (
                    <Flex
                        key={index}
                        width="calc(50% - 6px)"
                        minWidth="0"
                    >
                        <CitationCard
                            citation={citation}
                            onClick={() => handleCitationClick(citation)}
                        />
                    </Flex>
                ))}
            </Flex>
        </CollapsibleSection>
    );
};
